import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import { IAuthContext } from '../../context/auth/auth-context';
import withAuthContext from '../../context/auth/AuthConsumer';
import Paginations from './Pagination';
import {
  DataTable,
  DataTableCell,
  DataTableHeadCell,
  DataTableHeadRow,
  DataTableRow,
  DataTableShell,
} from '../ui';

interface IContactContainerProps {
  notifications: any[];
  getPeopleList: any;
  showItems: number;
  isLoad: boolean;
  orderCompany: any;
  setLoad: any;
  setOrderCompany: any;
  setOrderLocation: any;
  activeOrder: string;
  setActiveOrder: any;
  orderLocation: any;
  rows: any;
  setShowFrom: any;
  showFrom: any;
  onContactListReq: any;
}

const HeaderLabel = styled.div`
  font-size: 17px;
  font-weight: 600;
`;

const ContactContainer: React.FC<IContactContainerProps & { context: IAuthContext }> = (props) => {
  const {
    getPeopleList,
    showItems,
    isLoad,
    rows,
    setShowFrom,
    showFrom,
    onContactListReq,
  } = props;

  const onPreviousClick = async () => {
    setShowFrom(showFrom - showItems);
    getPeopleList(showFrom - showItems);
  };
  const onNextClick = async () => {
    setShowFrom(showFrom + showItems);
    getPeopleList(showFrom + showItems);
  };

  useEffect(() => {
    if (isLoad) {
      getPeopleList();
    }
  });

  return (
    <>
      <DataTableShell>
        <DataTable aria-label="Contacts table">
          <thead>
            <DataTableHeadRow>
              <DataTableHeadCell align="center"><HeaderLabel>Company</HeaderLabel></DataTableHeadCell>
              <DataTableHeadCell align="center"><HeaderLabel>Facility/Location</HeaderLabel></DataTableHeadCell>
              <DataTableHeadCell align="center"><HeaderLabel>Contacts</HeaderLabel></DataTableHeadCell>
            </DataTableHeadRow>
          </thead>
          <tbody>
            {rows.contacts &&
              rows.contacts.length > 0 &&
              rows.contacts.map((row: any, index: number) => (
                <DataTableRow key={row.entity_number + index} striped index={index}>
                  <DataTableCell style={{ textAlign: 'center' }}>{row.entity_name}</DataTableCell>
                  <DataTableCell>{row.city}</DataTableCell>
                  <DataTableCell style={{ textAlign: 'center' }}>
                    <Button
                      variant="link"
                      className="people-finder-table-link"
                      onClick={() => onContactListReq(row)}
                      style={{ color: '#5eead4', fontWeight: 600 }}
                    >
                      View contacts
                    </Button>
                  </DataTableCell>
                </DataTableRow>
              ))}
          </tbody>
        </DataTable>
      </DataTableShell>
      <Paginations
        isDisabled={false}
        isFirstPage={(rows && rows.records_num_from === 0) || false}
        isLastPage={
          (rows && rows.records_num_from + rows.records_num_show >= rows.total_records) || false
        }
        totalRecords={(rows && rows.total_records) || 0}
        onPreviousClick={onPreviousClick}
        onNextClick={onNextClick}
      />
    </>
  );
};
export default withAuthContext(ContactContainer);
